let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6ejFK"), load("g4ylS")]).then(() => parcelRequire('gbul6'));